import styled from 'styled-components'

const WrapContent = styled.div`
    display: flex;
    flex-direction: column;
    /* min-height: 920px; */
    overflow: hidden;
    .page-content {
        flex-grow: 1;
        overflow: auto;
    }
`;

export {
    WrapContent
}